import { useEffect, useState } from 'react';
import { type RouteObject, useLocation } from 'react-router';
import { router } from '../router';

export const useNavigationRoutes = () => {
    const { pathname } = useLocation();
    const [routes, setRoutes] = useState<RouteObject[]>([]);

    useEffect(() => {
        setRoutes(
            router.state.matches
                .map((match): RouteObject => match.route)
                .filter((route) => route.title || route.Title)
        )
    }, [pathname]);

    return routes;
}
